import { cn } from '@/lib/cn'
import { ChannelCell } from '@/components/channel-cell'

const CHANNEL_LABEL: Record<string, string> = {
  amazon: 'Amazon',
  amazon_now: 'Amazon Now',
  blinkit: 'Blinkit',
  zepto: 'Zepto',
  flipkart: 'Flipkart',
  flipkart_minutes: 'Flipkart Minutes',
  myntra: 'Myntra',
  ajio: 'Ajio',
  bbnow: 'BB Now',
  swiggy: 'Swiggy',
  instamart: 'Instamart',
  bigbasket: 'BigBasket',
  offline_b2b: 'Offline B2B',
}

export function channelLabel(channel: string | null | undefined): string {
  if (!channel) return '—'
  return CHANNEL_LABEL[channel.toLowerCase()] ?? channel
}

/**
 * Marketplace logo + human name as one inline label. Prefer this over
 * raw text anywhere the channel appears — the logo gives ops a shape-based
 * anchor before they even read the word.
 *
 * `logoUrl` comes from Vision (`GET /v1/channels` / `order.channelLogoUrl`)
 * and is the same Google-favicon URL pulse v1 uses.
 */
export function ChannelTag({
  channel,
  logoUrl,
  size = 14,
  className,
}: {
  channel: string
  logoUrl?: string | null
  size?: number
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 text-[12.5px] font-medium text-[color:var(--foreground)]',
        className,
      )}
    >
      <ChannelCell channel={channel} logoUrl={logoUrl} size={size} />
      <span>{channelLabel(channel)}</span>
    </span>
  )
}
